<template>
  <div class="bank-account-selector" :class="{ 'open-selector': openSelector, loading: loading }">
    <LoadingSpinner v-if="loading" />
    <div v-if="selectedAccount" @click="toggleDropdown" class="selected-account bankaccount">
      <div class="account-logo">
        <img v-if="selectedAccount.tink_credential" :src="selectedAccount.tink_credential.icon_url" :alt="selectedAccount.tink_credential.bank_name">
        <img v-if="selectedAccount.unifiedpostpaymentaccount && !selectedAccount.tink_credential" :src="getBankLogoUrl()" :alt="selectedAccount.unifiedpostpaymentaccount.bank_name">
        <font-awesome-icon v-if="!selectedAccount.unifiedpostpaymentaccount && !selectedAccount.tink_credential" icon="fa-solid fa-building-columns" />
      </div>
      <div class="account-name">
        <div class="account-name--descriptor">
          <span v-if="selectedAccount.alias">{{ selectedAccount.alias }}</span>
          <span class="iban" v-else>{{ selectedAccount.iban }}</span>
        </div>
        <div class="account-name--bankname">
          <span v-if="selectedAccount.tink_credential">{{ selectedAccount.tink_credential.bank_name }}</span>
          <span v-if="selectedAccount.unifiedpostpaymentaccount && !selectedAccount.tink_credential">{{ selectedAccount.unifiedpostpaymentaccount.bank_name }}</span>
          <span v-if="!selectedAccount.unifiedpostpaymentaccount && !selectedAccount.tink_credential">{{ selectedAccount.name }}</span>
        </div>
      </div>
      <font-awesome-icon :icon="selectorCaret" class="selector-caret" />
    </div>
    <div class="options-list-wrap" :style="cssVars">
      <overlay-scrollbars ref="reportsOverlayScroll" :options="scrollBarOptions">
        <div class="options-list">
          <div v-for="(bankaccount, index) in bankAccounts" :key="index + '_' + bankaccount.id" @click="selectAccount(bankaccount.id)" class="bankaccount" :class="{ selected: selectedId === bankaccount.id }">
            <div class="account-logo">
              <img v-if="bankaccount.tink_credential" :src="bankaccount.tink_credential.icon_url" :alt="bankaccount.tink_credential.bank_name">
              <img v-if="bankaccount.unifiedpostpaymentaccount && !bankaccount.tink_credential" :src="getBankLogoUrl(bankaccount)" :alt="bankaccount.unifiedpostpaymentaccount.bank_name">
              <font-awesome-icon v-if="!bankaccount.unifiedpostpaymentaccount && !bankaccount.tink_credential" icon="fa-solid fa-building-columns" />
            </div>
            <div class="account-name">
              <div class="account-name--descriptor">
                <span v-if="bankaccount.alias">{{ bankaccount.alias }}</span>
                <span class="iban" v-else>{{ bankaccount.iban }}</span>
              </div>
              <div class="account-name--bankname">
                <span v-if="bankaccount.tink_credential">{{ bankaccount.tink_credential.bank_name }}</span>
                <span v-if="bankaccount.unifiedpostpaymentaccount && !bankaccount.tink_credential">{{ bankaccount.unifiedpostpaymentaccount.bank_name }}</span>
                <span v-if="!bankaccount.unifiedpostpaymentaccount && !bankaccount.tink_credential">{{ bankaccount.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
export default {
  name: 'BankAccountSelector',
  components: { LoadingSpinner },
  data () {
    return {
      openSelector: false,
      selectedId: null,
      loading: true,
      scrollBarOptions: { 
        scrollbars: { 
          autoHide: "leave",
          dragScrolling: true,
          clickScrolling: true,
          touchSupport: true,
          snapHandle: true
        }, 
        overflowBehavior: { y: 'scroll', x: 'scroll' },
      }
    }
  },
  computed: {
    ...mapGetters ({
      bankAccounts: "bankStore/getBankAccounts"
    }),
    selectorCaret () {
      return (this.openSelector) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'
    },
    selectedAccount () {
      const selectedAccount = this.bankAccounts.find(account => account.id === this.selectedId)
      return (selectedAccount) ? selectedAccount : this.bankAccounts[0]
    },
    cssVars () {
      return {
        '--sel-items': this.bankAccounts.length,
      }
    }
  },
  watch: {
    selectedId(account_id) {
      this.setSelectedAccount(account_id)
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'filterStore/SET_UPDATE_FILTER_BANK') {
        const filters = state["filterStore"].filter;

        if (this.bankAccounts.length) {
          let bankAccountIds = this.bankAccounts.map(bankAccount => bankAccount.id);

          if (bankAccountIds.includes(filters.account)) {
            this.selectedId = filters.account;
          } else {
            this.selectedId = this.bankAccounts[0].id;
          }
        } else {
          this.selectedId = null;
        }

        this.loading = false
      }
    })
  },
  mounted () {
    this.loading = false
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
  },
  methods: {
    ...mapMutations({ setSelectedAccount: 'bankStore/SET_SELECTED_ACCOUNT' }),
    toggleDropdown () {
      this.openSelector = !this.openSelector
    },
    selectAccount (bank_id) {
      if (this.selectedId === bank_id) return false
      this.selectedId = bank_id
      this.openSelector = !this.openSelector
      this.$store.commit('filterStore/SET_BANK_ACCOUNT', bank_id)
      this.$nextTick(() => {
        this.$store.commit('filterStore/SET_UPDATE_FILTER_BANK')
      })
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.openSelector = false
      }
    },
    getBankLogoUrl(bankAccount) {
      if (!bankAccount)
        bankAccount = this.selectedAccount;

      if (bankAccount.unifiedpostpaymentaccount)
        return `${window.Urls['public-unifiedpost_bank_logo']()}'?payment_account_id=${bankAccount.unifiedpostpaymentaccount.payment_account_id}`;

      return "";
    }
  },
}
</script>

<style lang="scss" scoped>
  .bank-account-selector, .options-list {
    box-shadow: $filtersShadow;
    border-radius: $radiusMd;
    // background: $colorBlue100;
    background: white;
    padding: 0.5rem;
    width: 100%;
  }
  .bank-account-selector {
    position: relative;
    &.loading { overflow: hidden; }
    .selector-caret {
      position: absolute;
      top: 50%;
      right: 0.5rem;
      font-size: 18px;
      color: $colorBlue;
      transform: translateY(-50%);
    }
    .bankaccount {
      display: flex;
      align-items: center;
      border-radius: $radiusSm;
      .account-logo {
        border-radius: 100px;
        overflow: hidden;
        display: flex;
        height: 100%;
        aspect-ratio: 1;
        width: 40px;
        margin-right: 0.5rem;
        flex-shrink: 0;
        img { width: 100%; }

        background: #f2f2f2;

        display: flex;
        justify-content: center;
        align-items: center;
        .svg-inline--fa {
          font-size: 24px;
          opacity: 0.3;
        }
      }
      .account-name {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        white-space: nowrap;
        &--descriptor {
          font-family: 'DINNextLTPro-Medium';
          font-weight: bold;
          line-height: 1;
          white-space: nowrap;
          font-size: 18px;
        }
        &--bankname {
          font-size: 12px;
          color: #7A7A7A;
        }
        span { 
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .selected-account {
      height: 100%;
      cursor: pointer;
      .account-logo {
        height: 100%;
        aspect-ratio: 1;
        width: 48px;
      }
      .account-name {
        padding-right: 1.5rem;
        &--descriptor {
          font-size: 22px;
        }
        &--bankname {
          font-size: 14px;
        }
      }
    }
    &.open-selector {
      .options-list-wrap {
        $baseItemHeight: 56px;
        $itemHeight: calc(#{$baseItemHeight} + 0.5rem);
        $selHeight: calc(#{$itemHeight} * var(--sel-items));
        height: calc(#{$selHeight} + 0.5rem); // border size
      }
    }
    .options-list-wrap {
      position: absolute;
      top: calc(100% + 0.5rem);
      left: 0;
      height: 0;
      max-height: 300px;
      transition: height 0.2s ease-in-out;
      overflow: hidden;
      width: 100%;
      border-radius: $radiusMd;
      background: white;
      box-shadow: $dropdownShadow;
      z-index: 100;
      .os-host { height: 100%; }
      .os-content { padding: 0; }
      .options-list {
        background: white;
        box-shadow: none;
        .bankaccount {
          padding: 0.5rem;
          transition: all 0.2s ease;
          cursor: pointer;
          &.selected {
            opacity: 0.3;
            background-color: $colorUnassigned200;
            &:hover { background-color: $colorUnassigned200; }
          }
          &:hover {
            background-color: $colorBlue50;
          }
          &:not(:last-child) {
            margin-bottom: 0.5rem;
          }
        }
      }
      
    }
  }
</style>
